import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-08e5dc66"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "report-detail"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "total flex align-center justify-between"
};
var _hoisted_4 = {
  class: "header flex align-center justify-between"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});
var _hoisted_6 = {
  class: "title"
};
var _hoisted_7 = {
  class: "time"
};
var _hoisted_8 = {
  class: "info"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "供应商", -1);
});
var _hoisted_10 = {
  class: "value"
};
var _hoisted_11 = {
  class: "info"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "车牌号", -1);
});
var _hoisted_13 = {
  class: "value"
};
var _hoisted_14 = {
  class: "info"
};
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "净重(吨)", -1);
});
var _hoisted_16 = {
  class: "value"
};
var _hoisted_17 = {
  class: "info"
};
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "金额(元)", -1);
});
var _hoisted_19 = {
  class: "value"
};
var _hoisted_20 = {
  key: 1,
  class: "box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_type_tab = _resolveComponent("c-type-tab");
  var _component_c_date_header_with_btn = _resolveComponent("c-date-header-with-btn");
  var _component_van_list = _resolveComponent("van-list");
  var _component_c_no_data = _resolveComponent("c-no-data");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_c_type_tab, {
    onConfirmType: _ctx.confirmType
  }, null, 8, ["onConfirmType"]), _createVNode(_component_c_date_header_with_btn, {
    ref: "dateRef",
    showBtn: false,
    type: _ctx.params.type,
    onConfirmDate: _ctx.confrimDate
  }, null, 8, ["type", "onConfirmDate"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, "车次(车)：" + _toDisplayString(_ctx.totalData.totalSingular), 1), _createElementVNode("span", null, "进料量(吨)：" + _toDisplayString(_ctx.totalData.totalSettleValue), 1), _createElementVNode("span", null, "金额(万元)：" + _toDisplayString(_ctx.totalData.totalMoney), 1)]), _ctx.list.length ? (_openBlock(), _createBlock(_component_van_list, {
    key: 0,
    loading: _ctx.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.loading = $event;
    }),
    finished: _ctx.finished,
    "finished-text": "没有更多了",
    onLoad: _ctx.onLoad
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "box"
        }, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString(item.stone_name), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(item.settlement_time), 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(item.supplier_name), 1)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", _hoisted_13, _toDisplayString(item.plate_number), 1)]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", _hoisted_16, _toDisplayString(item.net_weight), 1)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("span", _hoisted_19, _toDisplayString(item.tot_money), 1)])]);
      }), 128))];
    }),
    _: 1
  }, 8, ["loading", "finished", "onLoad"])) : _createCommentVNode("", true), !_ctx.list.length ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_c_no_data)])) : _createCommentVNode("", true)])]);
}